/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { deepCloneObject } from '../../../global/js/utils/deepCloneObject';
import { rangeWithCallback } from '../../../global/js/utils/rangeWithCallback';
export var handleCellDeletion = function handleCellDeletion(_ref) {
  var selectionAreas = _ref.selectionAreas,
      currentMatcher = _ref.currentMatcher,
      rows = _ref.rows,
      setActiveCellContent = _ref.setActiveCellContent,
      updateData = _ref.updateData;
  var selectionAreaClone = deepCloneObject(selectionAreas);
  var indexOfCurrentSelectionArea = selectionAreaClone.findIndex(function (item) {
    return item.matcher === currentMatcher;
  });
  var selectionAreaToEmptyContents = selectionAreaClone[indexOfCurrentSelectionArea];
  var lowestColumnIndex = Math.min(selectionAreaToEmptyContents.point1.column, selectionAreaToEmptyContents.point2.column);
  var greatestColumnIndex = Math.max(selectionAreaToEmptyContents.point1.column, selectionAreaToEmptyContents.point2.column);
  var lowestRowIndex = Math.min(selectionAreaToEmptyContents.point1.row, selectionAreaToEmptyContents.point2.row);
  var greatestRowIndex = Math.max(selectionAreaToEmptyContents.point1.row, selectionAreaToEmptyContents.point2.row);
  rangeWithCallback(lowestColumnIndex, greatestColumnIndex, function (columnIndex) {
    rangeWithCallback(lowestRowIndex, greatestRowIndex, function (rowIndex) {
      var cellProps = rows[rowIndex].cells[columnIndex];
      updateData(rowIndex, cellProps === null || cellProps === void 0 ? void 0 : cellProps.column.id, '');
    });
  });
  setActiveCellContent(null);
};